import React from 'react';

const InfoField = ({ label, value, subValue, className = '', valueClassName = '' }) => {
  return (
    <div className={`border border-base-300 rounded-xl p-4 flex flex-col gap-1 bg-base-100 ${className}`}>
      <span className="text-xs font-semibold text-base-content/50 uppercase tracking-wider">{label}</span>
      <strong className={`text-sm md:text-base text-base-content font-bold ${valueClassName}`}>
        {value}
      </strong>
      {subValue && <small className="text-xs text-base-content/70 mt-1">{subValue}</small>}
    </div>
  );
};

export default InfoField;
